import React, { useEffect, useState } from "react";
import { getSessionData } from "./baseHelper";

function useAuthUser() {
  const [userId, setUserId] = useState("");
  const [store, setStore] = useState({});

  useEffect(() => {
    setUserId(getSessionData({ key: "userId" }));
    const store = JSON.parse(getSessionData({ key: "store" }));
    setStore(store);
  }, []);

  return { userId, storeId: store.storeid, store };
}

export default useAuthUser;
